<div class="component-main-container">

  <app-page-header parentTitle='{{"report-audit-edit.parentTitle" | translate}}'
    pageTitle='{{"report-audit-edit.pageTitle" | translate}}'></app-page-header>

  <div class="row">
    <div class="col-lg-5 col-xl-4 col-sm-12">
      <div class="component-forms-box">
        <!--Dados da auditoria-->
        <div class="form-fields-box">
          <h2 class="header-link">{{'report-audit-edit.form-title' | translate}}</h2>
          <hr>
          <!-- Passo de preencher referencia -->
          <div class="form-step">
            <div class="circle-number"> 1
            </div>
            <div class="input-text">
              <p-floatlabel variant="on">
                <input pInputText fluid id="reference" [formControl]="referenceForm" [disabled]="true" type="text" />
                <label for="reference">{{'general-simple-label.reference-label' |
                  translate}}</label>
              </p-floatlabel>
            </div>
          </div>

          <div class="form-step">
            <div class="circle-number"> 2 </div>
            <div class="date-picker-input">
              <p-floatlabel variant="on">
                <p-datepicker id="auditDate" selectionMode="range" [readonlyInput]="true" [maxDate]="maxDate"
                  appendTo="body" dateFormat="dd/mm/yy" showIcon iconDisplay="input" [formControl]="auditDateForm"
                  (onSelect)="changeAuditField()">
                </p-datepicker>
                <label for="auditDate">{{'report-audit-edit.date-range-label' | translate}}</label>
              </p-floatlabel>

            </div>

          </div>
          <div>
            @if (auditDateForm.value?.[0] && !auditDateForm.value?.[1]) {
            <p-message severity="info" size="small">
              <i class="pi pi-info-circle"></i>
              {{ 'report-audit-edit.select-end-date' | translate }}
            </p-message>
            }
            @if (!auditDateForm.value?.[0] && !auditDateForm.value?.[1]) {
            <p-message severity="error" size="small">
              {{ 'report-audit-edit.required-data-audit' | translate }}
            </p-message>
            }
          </div>

          <!-- <button *ngIf="auditIsOpen" (click)="saveBasicAuditData()" [disabled]="!auditDataWasModified" class="btn btn-success mb-2 w-100">Editar
              dados</button> -->
        </div>

        @if (auditIsOpen) {
        <!--Adicionar nova instalação-->
        <div class="form-fields-box">
          <h2>{{'report-audit-edit.add-new-installation' | translate}}</h2>
          <hr>
          <!-- PASSO 1 -->
          <div class="">
            <div class="step-title">
              <span class="circle-number-steps">1</span>
              <span>{{ 'report-audit-edit.search-installation' | translate }}</span>
            </div>

            <div class="input-text">
              <p-inputgroup>
                <p-floatlabel variant="on">
                  <input pInputText fluid id="searchInstallation" [formControl]="searchInstallationForm" type="text" />
                  <label for="searchInstallation">{{'general-simple-label.add-reference' |
                    translate}}</label>
                </p-floatlabel>

                <p-inputgroup-addon>
                  <button pButton type="button" icon="pi pi-search" class="p-button-text component-search-icon-button"
                    [disabled]="!auditIsOpen || !searchInstallationForm.valid" (click)="searchInstallation()"
                    aria-label="Clear">
                  </button>
                </p-inputgroup-addon>
              </p-inputgroup>
            </div>
          </div>

          @if (isLoadingNewInstallation) {
          <div class="component-spinner-box-sm">
            <p-progress-spinner strokeWidth="8" fill="transparent" animationDuration=".5s"
              [style]="{ width: '30px', height: '30px' }"></p-progress-spinner>
          </div>
          }
          <!-- adicionar novas instalações-->
          <div>

            <div class="step-title">
              <span class="circle-number-steps">2</span>
              <span>{{ 'report-audit-edit.import-file-optional' | translate }}</span>
            </div>

            <div class="form-step inputFile">

              <div class="w-full ">
                <p-inputgroup>
                  <input pInputText type="file" class="form-control align-items-top" id="inputGroupFile04"
                    [accept]="'.csv'" aria-describedby="inputGroupFileAddon04" aria-label="Upload" #fileUploadSimple
                    (change)="getTextFromFile($event)">

                  <p-inputgroup-addon class="p-0">
                    @if (!isLoadingImportFilter) {

                    <button pButton severity="secondary" class="p-button-text h-full px-4" type="button"
                      id="inputGroupFileAddon04" [disabled]="!disabledImportButton" (click)="importDataFromCSV()">
                      {{'general-simple-label.import-button' | translate}}
                    </button>
                    }
                    @if (isLoadingImportFilter) {
                    <div class="px-3 flex align-items-center">
                      <p-progress-spinner strokeWidth="8" fill="transparent" animationDuration=".5s"
                        [style]="{ width: '30px', height: '30px' }"></p-progress-spinner>
                    </div>
                    }
                  </p-inputgroup-addon>

                </p-inputgroup>
              </div>
            </div>
          </div>

          <button pButton icon="pi pi-download" [outlined]="true" class="h-full px-4 my-2" type="button"
            id="inputGroupFileAddon04" (click)="downloadCsvFile()">
            {{'general-simple-label.download-model-import' | translate}}
          </button>

          @if (auditIsOpen && installationList.length) {
          <div>
            <div class="step-title">
              <span class="circle-number-steps">3</span>
              <span>{{ 'report-audit-edit.selected-installations' | translate }} ({{installationList.length}})</span>
            </div>
            <div class="form-step mb-4">
              <button pButton type="button" severity="info" (click)="openModalWithInstallations()"
                class="w-100 pb-2 ms-1 me-1 mb-3">
                {{'report-audit-edit.selected-installations' |
                translate}}
              </button>
            </div>
          </div>

          }
          @if (auditIsOpen && installationList.length > 0) {
          <div>
            <div class="step-title">
              <span class="circle-number-steps">4</span>

              <span>{{ 'report-audit-edit.add-installations' | translate }}</span>
            </div>

            <div class="form-step mb-4">
              <button pButton icon="pi pi-plus-circle" type="button" (click)="addNewInstallationToAudit()"
                class="w-100 pb-2 ms-1 me-1 mb-3">
                {{'general-simple-label.add-installation' | translate}}
              </button>
            </div>

          </div>

          }
        </div>
        }
      </div>
    </div>

    <div class="col-lg-7 col-xl-8 col-sm-12">
      <div class="component-table-action-buttons" style="display: flex; justify-content: space-between;">
        <div>
          @if (!installationDataWasModified && !auditDataWasModified) {
          <button pButton icon="pi pi-chevron-left" type="button" class="m-1 mt-2 mb-2" (click)="backToAuditTables()">
            {{'report-audit-edit.back-to-audit' | translate}}
          </button>
          }
          @if (installationDataWasModified || auditDataWasModified) {
          <button pButton icon="pi pi-times" type="button" severity="danger" class="m-1 mt-2 mb-2"
            (click)="backToAuditTables()">

            {{'report-audit-edit.discard-go-back-to-audit' | translate}}
          </button>
          }
        </div>

        <div>
          @if (installationDeletionList.length > 0) {
          <button pButton type="button" severity="danger" class="m-1 mt-2 mb-2" (click)="deleteInstallations()">
            {{'report-audit-edit.delete-selected-installation' | translate}}
          </button>
          }
          @if (auditIsOpen && (installationDataWasModified || installationList.length > 0 || auditDataWasModified)) {
          <button pButton icon="pi pi-check" type="button" class="m-1 mt-2 mb-2" (click)="saveAuditNewData()">
            {{'report-audit-edit.save-audit' | translate}}
          </button>
          }
          @if (canCloseAudit) {
          <button pButton icon="pi pi-check" type="button" severity="warn" class="m-1 mt-2 mb-2" (click)="closeAudit()">
            {{'report-audit-edit.close-audit' | translate}}
          </button>
          }
        </div>
      </div>

      <div class="table-container">
        <p-table dataKey="id" [value]="auditInstallationSet">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="delete" style="width: 12.50%">
                <p-checkbox [binary]="true" (onChange)="selectAllinstallationForDeletion($event)"></p-checkbox>
              </th>

              <th pSortableColumn="installationReference">
                {{'report-audit-edit.table-header.point' | translate}}
              </th>

              <th pSortableColumn="transmissionComplianceIndicator">ICTI</th>
              <th pSortableColumn="icvi">ICVI</th>
              <th pSortableColumn="sdft">SDFT</th>
              <th pSortableColumn="register">{{'report-audit-edit.table-header.register' | translate}}
              </th>
              <th pSortableColumn="status">{{'report-audit-edit.table-header.status' | translate}}</th>
              <th pSortableColumn="variables">
                {{'report-audit-edit.table-header.variables' | translate}}
              </th>
              <th pSortableColumn="daytimeOperation">OPDIU</th>
              <th pSortableColumn="nighttimeOperation">OPNOT</th>
              <th pSortableColumn="actuation">
                {{'report-audit-edit.table-header.actuation' | translate}}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
            <tr>
              <td>
                <p-checkbox [ngModel]="row.checked" [ngModelOptions]="{standalone: true}" [binary]="true"
                  (onChange)="selectInstallationForDeletion($event, row.installationId)">
                </p-checkbox>
              </td>
              <td> {{row.installationReference}}</td>
              <td>
                <p-checkbox [ngModel]="row.transmissionComplianceIndicator" [ngModelOptions]="{standalone: true}"
                  [binary]="true" [disabled]="true">
                </p-checkbox>
              </td>
              <td>-</td>
              <td>
                <p-checkbox [ngModel]="row.register && row.status && row.variables && row.actuation"
                  [ngModelOptions]="{standalone: true}" [binary]="true" [disabled]="true">
                </p-checkbox>
              </td>
              <td>
                <p-checkbox [ngModel]="row.register" [ngModelOptions]="{standalone: true}" [binary]="true"
                  [disabled]="!auditIsOpen"
                  (onChange)="changeInstallationField($event, 'register', row.installationId)"></p-checkbox>
              </td>
              <td>
                <p-checkbox [ngModel]="row.status" [ngModelOptions]="{standalone: true}" [binary]="true"
                  [disabled]="!auditIsOpen" (onChange)="changeInstallationField($event, 'status', row.installationId)">
                </p-checkbox>
              </td>
              <td>
                <p-checkbox [ngModel]="row.variables" [ngModelOptions]="{standalone: true}" [binary]="true"
                  [disabled]="!auditIsOpen"
                  (onChange)="changeInstallationField($event, 'variables', row.installationId)">
                </p-checkbox>
              </td>
              <td>
                <p-checkbox [ngModel]="row.daytimeOperation" [ngModelOptions]="{standalone: true}" [binary]="true"
                  [disabled]="!auditIsOpen"
                  (onChange)="changeInstallationField($event, 'daytimeOperation', row.installationId)">
                </p-checkbox>
              </td>
              <td>
                <p-checkbox [ngModel]="row.nighttimeOperation" [ngModelOptions]="{standalone: true}" [binary]="true"
                  [disabled]="!auditIsOpen"
                  (onChange)="changeInstallationField($event, 'nighttimeOperation', row.installationId)"></p-checkbox>
              </td>
              <td>
                <p-checkbox [ngModel]="row.actuation" [ngModelOptions]="{standalone: true}" [binary]="true"
                  [disabled]="!auditIsOpen"
                  (onChange)="changeInstallationField($event, 'actuation', row.installationId)"></p-checkbox>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr>
              <td></td>
              <td>{{'report-audit-edit.table-header.sample-total' | translate}}</td>
              <td>{{auditDataTotal ? (auditDataTotal.icti ? auditDataTotal.icti : '-') : '-'}}</td>
              <td></td>
              <td>SDFT: </td>
              <td> {{auditDataTotal ? (auditDataTotal.register ? auditDataTotal.register : '-') : '-' }}
              </td>
              <td> {{auditDataTotal ? (auditDataTotal.state ? auditDataTotal.state : '-') : '-' }}</td>
              <td>{{auditDataTotal ? (auditDataTotal.variables ? auditDataTotal.variables : '-') : '-' }}
              </td>
              <td>{{auditDataTotal ? (auditDataTotal.opdiu ? auditDataTotal.opdiu : '-') : '-' }}</td>
              <td>{{auditDataTotal ? (auditDataTotal.opnot ? auditDataTotal.opnot : '-') : '-' }}</td>
              <td> {{auditDataTotal ? (auditDataTotal.actuation ? auditDataTotal.actuation : '-') : '-'}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>